import { render, staticRenderFns } from "./MCQ.vue?vue&type=template&id=92a5c472&"
import script from "./MCQ.vue?vue&type=script&lang=ts&"
export * from "./MCQ.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports